import { useEffect } from "react";
import "./ChecInOutConfirmation.css";
import checkout from "../images/checkout.png";

export default function CheckinSuccess({ stand, info, check, onDone }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDone(); // tell App to switch screen
      console.log("Timeout completed, calling onDone");
    }, 3000);

    return () => clearTimeout(timer);
  }, [onDone]);
  console.log("test");
  return (
    <div className="success-container">
      {/* Content */}
      <div className="success-content">
        <div className="success-circle">
          {check === "checkout" ? (
            <img src={checkout} alt="logo" className="checkmark" />
          ) : (
            <span className="checkmark">✓</span>
          )}
        </div>
        <p className="success-text">
          Die{" "}
          <strong>{`${stand === 11 ? "Polyhalle" : `Bahn ${stand}`}`}</strong>{" "}
          wurde {check === "checkout" ? "Ausgecheckt" : "Eingecheckt"}
          <br />
          {/* {info} */}
        </p>
      </div>
    </div>
  );
}
